import { render, staticRenderFns } from "./LayoutBindUsers.vue?vue&type=template&id=4d5ad8d8"
import script from "./LayoutBindUsers.vue?vue&type=script&lang=js"
export * from "./LayoutBindUsers.vue?vue&type=script&lang=js"
import style0 from "./LayoutBindUsers.vue?vue&type=style&index=0&id=4d5ad8d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports